module.exports = __webpack_public_path__ + "static/media/ro-RO.b3115e65.md";